import moment from 'moment';
import { instanceApi } from '../../services';
import { ClientFilterType } from './IBDashboardModels';

export const getCurrencies = (): Promise<any> =>
  instanceApi.get('api/PartnersManagement/GetCurrencies');

export const getGeneralSettings = (): Promise<any> =>
  instanceApi.post('api/settings/getgeneralsettings');

export const getPartnerSettings = (key: string): Promise<any> =>
  instanceApi.get(`api/PartnersManagement/GetPartnerSetting?key=${key}`);

export const getPartnerPartnerships = (showExpired: boolean): Promise<any> =>
  instanceApi.get(`api/Dashboard/GetPartnerPartnerships?showExpired=${showExpired}`);

export const setPartnerSettings = (key: string, value: string): Promise<any> =>
  instanceApi.post('api/PartnersManagement/SetPartnerSetting', { key, value });

export const getAggregatedValues = (
  partnershipCode: string,
  startDate: Date,
  endDate: Date,
  clientFilterType: ClientFilterType,
): Promise<any> =>
  instanceApi.get(
    `/api/dashboard/getdashboardaggregatedestimatedvalues?partnershipCode=${partnershipCode}&startDate=${moment(startDate).format(
      'YYYY-MM-DD',
    )}&endDate=${moment(endDate).format('YYYY-MM-DD')}&ClientFilterType=${clientFilterType}`,
  );

export const getDashboardValues = (clientFilterType: ClientFilterType): Promise<any> =>
  instanceApi.get(`api/partners/partners/dashboard?ClientFilterType=${clientFilterType}`);

export const getHighlightData = (
  fromDate: Date,
  toDate: Date,
  partnershipCode: string,
  highlightType: number,
  clientFilterType: ClientFilterType,
): Promise<any> =>
  instanceApi.get(
    `api/Dashboard/getHighlightData?FromDate=${moment(fromDate).format('YYYY-MM-DD')}&ToDate=${moment(toDate).format(
      'YYYY-MM-DD',
    )}&PartnershipCode=${partnershipCode}&HighlightType=${highlightType}&ClientFilterType=${clientFilterType}`,
  );

export const getBrokers = async (): Promise<any> =>
  instanceApi.get('api/brokersmanagement/getbrokers');

export const triggerManualCalculation = (): Promise<any> =>
  instanceApi.put('api/dashboard/update');
  